import { forwardRef, ReactElement, ReactNode, Ref, useState } from 'react';
import { Actions, DockLocation, TabNode } from 'flexlayout-react'
import { Nav } from 'rsuite'
import { hasPermission } from '@/shared'
import { Views } from '@client/config/views'
import sidebarStore from '@client/stores/sidebarStore'
import { useLayout } from './LayoutManager'
import { ETabSet } from '@client/stores/tabsStore'

export type SidebarDataProps = {
    id: string,
    name: string,
    tabSet: ETabSet
}

interface NavigationProps {
    //onSidebarOpen: (sidebar: SidebarDataProps) => void;
    ref: Ref<HTMLElement>
}
interface NavigationItemProps {
    name: string,
    label: string,
    icon: ReactElement,
    selected: boolean,
    onOpen: (sidebar: SidebarDataProps) => void,
}

// Outside LeftNavigation on purpose: declared inside, it was a new component on
// every draw, and React built every entry anew. With the panes following the
// splitter that was every step of a drag, and the icon loaded from a file
// blinked (operator, 15.10.2026).
const NavigationItem = ({ name, icon, label, selected, onOpen }: NavigationItemProps) => {
    const classes = ['navigation-link']
    if (selected) classes.push('active')

    return (
        <Nav.Item
            title={label}
            className={classes.join(' ')}
            onClick={() => onOpen({ id: `sidebar-${name}`, name, tabSet: ETabSet.SIDEBAR })}
        >
            {icon}
        </Nav.Item>
    )
}

type NavGroupProps = { children: ReactNode }
const NavGroup = ({ children }: NavGroupProps) => {
    if (!children || (children as any[]).length == 0) return null

    return (
        <div className='group-view'>
            {children}
        </div>
    )
}

const LeftNavigation = forwardRef<HTMLElement, NavigationProps>(
    ({ }, ref) => {
        const { model } = useLayout()
        const [activeKey, setActiveKey] = useState('')

        const handleSidebarOpen = (sidebarData: SidebarDataProps) => {
            if (sidebarData.name === activeKey && sidebarStore.sidebarVisible.value) {
                sidebarStore.sidebarVisible.value = false
                return
            }

            setActiveKey(sidebarData.name)
            sidebarStore.sidebarVisible.value = true

            if (!sidebarStore.isSidebarOpen(sidebarData.id)) {
                sidebarStore.addSidebar(sidebarData)
            }

            if (model) {
                const existingNode = model.getNodeById(sidebarData.id) as TabNode | undefined;
                if (existingNode) {
                    model.doAction(Actions.selectTab(sidebarData.id));
                } else {
                    model.doAction(Actions.addNode({
                        type: 'tab',
                        id: sidebarData.id,
                        name: sidebarData.name,
                        component: sidebarData.name,
                        config: sidebarData,
                    },
                        sidebarData.tabSet,
                        DockLocation.CENTER,
                        -1
                    ))
                }
            }
        }

        return (
            <Nav id="navigation" ref={ref as any} activeKey={activeKey} style={{ margin: 0 }}>
                {Views().map((group, index) =>
                    <NavGroup key={index}>
                        {group.views.filter(item => {
                            return hasPermission(item.capability)
                        }).map(item => {
                            return <NavigationItem key={item.key} name={item.key} icon={item.icon as any} label={item.label} selected={item.key == activeKey} onOpen={handleSidebarOpen} />
                        })}
                    </NavGroup>
                )}
            </Nav>
        )
    }
)

export default LeftNavigation;